/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Ageingruppierung21Inputs */



/**

* @param {_Field_Ageingruppierung21Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_ageingruppierung21 = /** @type {((inputs?: _Field_Ageingruppierung21Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Ageingruppierung21Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("AG-Eingruppierung 2")
});
export { _field_ageingruppierung21 as "_field_agEingruppierung2" }